module.exports = __webpack_public_path__ + "img/white00_128.f6a0c76e.png";